export default __webpack_public_path__ + "static/videoBackground-15302cb7805cdd166cd37132b5b59619.mp4";